import { render } from "./masterClassList.vue?vue&type=template&id=ad4dd5a6&scoped=true&ts=true"
import script from "./masterClassList.vue?vue&type=script&lang=ts"
export * from "./masterClassList.vue?vue&type=script&lang=ts"

import "./masterClassList.vue?vue&type=style&index=0&id=ad4dd5a6&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad4dd5a6"]])

export default __exports__